<template>
  <div v-if="hasRecruiterKpiPermission" class="recruiter-kpi-content">
    <RecruiterKpiDashboard
      class="dashboard"
      notSaveQuery
      hiddenFilterTitle
      cascaderSize="small"
    />
  </div>
</template>

<script>
import RecruiterKpiDashboard from './recruiterKpiDashboard.vue'
import mixin from './mixin'

export default {
  mixins: [mixin],
  components: {
    RecruiterKpiDashboard
  },
  data () {
    return {

    }
  },
  created () {

  }
}
</script>

<style lang="scss" scoped>
.recruiter-kpi-content {
  position: relative;
  padding: 20px;
  margin-bottom: 15px;
  border-radius: 6px;
  color: #303133;
  background: #fff;

  .dashboard {
    ::v-deep {
      .list-page {
        .list-head {
          .title {
            font-weight: bold;
          }
        }

        .search-filter {
          .search-filter-container {
            .el-input__inner {
              height: 34px;
              line-height: 34px;
            }

            .start-end-date-picker {
              width: 30%;

              .el-icon-date {
                line-height: 26px;
              }

              .el-range-separator {
                line-height: 26px;
              }
            }
          }
        }

        .list-container {
          .el-table {
            z-index: 1;
          }
        }
      }
    }
  }
}
</style>
